<div *ngIf="config && config.id == 'Strategies'">
  <div *ngFor="let subSubPanel of config.list; let i = index" [class.hidden]="!parentOpenState"
       class="sub-sub panel-wrapper">
    <mat-expansion-panel [expanded]="panelsOpenStates[i]" (opened)="panelsOpenStates[i] = true"
                         (closed)="panelsOpenStates[i] = false" hideToggle="true" class="overflow-visible">
      <mat-expansion-panel-header tabindex="0" [attr.aria-label]="subSubPanel.title + (panelsOpenStates[i] ? ', expanded' : ', collapsed')" [collapsedHeight]="'auto'" [expandedHeight]="'auto'" class="taxanomy-header p-0">
        <mat-panel-title class="align-items-center">
          <div class="taxanomy-number text-center row align-items-center"
               [style.background-color]="addAlpha(color, 0.2, 'xs')">
            <span [style.color]="color">{{subSubPanel.title}}</span>
          </div>
          <span class="panel-header-text">
            <app-dynamic-content
              [contentId]="'action-plan-sub-desc'"
              [htmlContent]="subPanel.description">
            </app-dynamic-content>
          </span>
          <div class="arrows">
            <div tabindex="0" role="button" [attr.aria-label]="(panelsOpenStates[i] ? 'Collapse' : 'Expand') + ' ' + subSubPanel.title" (keydown)="onArrowKeydown($event, i)">
            <svg [style.fill]="color" class="taxanomy-arrow-up" *ngIf="panelsOpenStates[i]"
                 xmlns="http://www.w3.org/2000/svg" width="49.61" height="49.61" viewBox="0 0 49.61 49.61">
              <path class="a"
                    d="M24.805,49.61A24.805,24.805,0,0,1,7.265,7.265a24.805,24.805,0,0,1,35.08,35.08A24.643,24.643,0,0,1,24.805,49.61Zm0-45.735A20.929,20.929,0,1,0,45.735,24.805,20.953,20.953,0,0,0,24.805,3.876ZM38.2,21.511,35.464,18.77,24.805,29.429,14.147,18.77l-2.741,2.741,13.4,13.4Zm0,0"
                    transform="translate(49.61 49.61) rotate(180)"/>
            </svg>

            <svg [style.fill]="color" class="taxanomy-arrow-down" *ngIf="!panelsOpenStates[i]"
                 xmlns="http://www.w3.org/2000/svg" width="49.61" height="49.61" viewBox="0 0 49.61 49.61">
              <path class="a"
                    d="M24.805,49.61A24.805,24.805,0,0,1,7.265,7.265a24.805,24.805,0,0,1,35.08,35.08A24.643,24.643,0,0,1,24.805,49.61Zm0-45.735A20.929,20.929,0,1,0,45.735,24.805,20.953,20.953,0,0,0,24.805,3.876ZM38.2,21.511,35.464,18.77,24.805,29.429,14.147,18.77l-2.741,2.741,13.4,13.4Zm0,0"
                    transform="translate(0)"/>
            </svg>
          </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <table multiTemplateDataRows *ngIf="panelsOpenStates[i]" mat-table [dataSource]="subSubPanel.list" class="w-100">

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef
              class="action">{{columnNames.column1title ? columnNames.column1title : 'Action'}}  </th>
          <td mat-cell *matCellDef="let element" class="action font-weight-bold" [style.background-color]="addAlpha(color, 1, 'xs')"
              [style.color]="getActionTextColor()"> {{element.title}} </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef
              class="description">{{columnNames.column2title ? columnNames.column2title : 'Description'}}  </th>
          <td mat-cell *matCellDef="let element" class="description">
            <app-dynamic-content
              [contentId]="'action-plan-sub-el-desc'"
              [htmlContent]="element.description">
            </app-dynamic-content>
          </td>
        </ng-container>

        <ng-container matColumnDef="timeline-header">
          <td colspan="2" mat-cell *matCellDef="let element" class="timeline-header">
            <div class="merged-cells-container">
              <span class="merged-cell-left">{{columnNames.column3title ? columnNames.column3title : 'Timeline'}}</span>
              <span class="merged-cell-right" [style.color]="color">{{element.timeline}}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="timeline">
          <th mat-header-cell *matHeaderCellDef
              class="timeline"> {{columnNames.column3title ? columnNames.column3title : 'Timeline'}} </th>
          <td mat-cell *matCellDef="let element" class="timeline font-weight-bold" [style.color]="color"> {{element.timeline}} </td>
        </ng-container>

        <ng-container matColumnDef="status-header">
          <td colspan="2" mat-cell *matCellDef="let element" class="status-header">
            <div class="merged-cells-container">
              <span class="merged-cell-left">{{columnNames.column4title ? columnNames.column4title : 'Status'}}</span>
              <span class="merged-cell-right">
                <span
                  *ngIf="!isActionLayout(element)"
                  class="status-cintainer waves-light" (mouseenter)="applyStyles(element.status.value)"
                  [matTooltipPosition]="toolTipPosition" [matTooltip]="element.status.value">
                  <span class="status" [style.background-color]="
              element.status.value == 'Complete' ? '#35C13B'
              : element.status.value == 'In Progress' ? '#2492D6'
              : '#FFCE00'" [style.width]="
                element.status.value == 'Complete' ? '100%'
                : element.status.value == 'In Progress' ? '70%'
                : '30%'"></span>
                </span>
                <span
                  *ngIf="isActionLayout(element)"
                  class="description simple-text-benefits"
                  [innerHtml]="element.simpleTextStatus"></span>
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef
              class="status"> {{columnNames.column4title ? columnNames.column4title : 'Status'}} </th>
          <td mat-cell *matCellDef="let element" class="status">
            <span *ngIf="!isActionLayout(element)">
              <span class="status-cintainer waves-light" (mouseenter)="applyStyles(element.status.value)"
                    [matTooltipPosition]="toolTipPosition" [matTooltip]="element.status.value">
              <span class="status" [style.background-color]="
            element.status.value == 'Complete' ? '#35C13B'
            : element.status.value == 'In Progress' ? '#2492D6'
            : '#FFCE00'" [style.width]="
              element.status.value == 'Complete' ? '100%'
              : element.status.value == 'In Progress' ? '70%'
              : '30%'"></span>
            </span>
            </span>

            <span *ngIf="isActionLayout(element)" class="description simple-text-benefits" [innerHtml]="element.simpleTextStatus">

            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="coBenefits-header">
          <td colspan="2" mat-cell *matCellDef="let element" class="coBenefits-header pr-0">
            <div class="merged-cells-container">
              <span
                class="merged-cell-left pr-0">{{columnNames.column5title ? columnNames.column5title : 'Co Benefits'}}</span>
              <span class="merged-cell-right" *ngIf="!isActionLayout(element)">
                <img *ngFor="let coBenefit of element.coBenefits" (mouseenter)="applyStyles(coBenefit.title)"
                     [matTooltipPosition]="toolTipPosition" [matTooltip]="getCoBenefitTitle(coBenefit)"
                     src="{{getCoBenefitIconPath(coBenefit)}}">
              </span>
              <span class="merged-cell-right" *ngIf="isActionLayout(element)">
                <span class="d-flex align-items-center justify-content-center simple-text-benefits description" [innerHtml]="element.simpleTextCoBenefits"></span>
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="coBenefits">
          <th mat-header-cell *matHeaderCellDef
              class="co-benefits pr-0">{{columnNames.column5title ? columnNames.column5title : 'Co Benefits'}} </th>
          <td mat-cell *matCellDef="let element" class="co-benefits">
            <span *ngIf="!isActionLayout(element)">
              <img *ngFor="let coBenefit of element.coBenefits" (mouseenter)="applyStyles(coBenefit.title)"
                   [matTooltipPosition]="toolTipPosition"
                   [matTooltip]="getCoBenefitTitle(coBenefit)" src="{{getCoBenefitIconPath(coBenefit)}}">
            </span>
            <span *ngIf="isActionLayout(element)" class="d-flex align-items-center justify-content-center simple-text-benefits description" [innerHtml]="element.simpleTextCoBenefits"></span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" tabindex="0" [attr.aria-label]="getRowAriaLabel(row)"></tr>

        <div *ngIf="isMobile()">
          <tr mat-row *matRowDef="let row; columns: ['timeline-header'];"></tr>
          <tr mat-row *matRowDef="let row; columns: ['status-header'];"></tr>
          <tr mat-row *matRowDef="let row; columns: ['coBenefits-header'];"></tr>
        </div>
      </table>

    </mat-expansion-panel>
  </div>
</div>

<div *ngIf="config && config.id == 'Actions'" class="sub-sub panel-wrapper include-actions">
  <table multiTemplateDataRows  mat-table [dataSource]="config.list" class="w-100">

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef
          class="action">{{columnNames.column1title ? columnNames.column1title : 'Action'}}  </th>
      <td mat-cell *matCellDef="let element" class="action" [style.background-color]="addAlpha(color, 1, 'xs')"
          [style.color]="getActionTextColor()"> {{element.title}} </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef
          class="description">{{columnNames.column2title ? columnNames.column2title : 'Description'}}  </th>
      <td mat-cell *matCellDef="let element" class="description">
        <app-dynamic-content
          [contentId]="'action-plan-sub-el-desc'"
          [htmlContent]="element.description">
        </app-dynamic-content>
      </td>
    </ng-container>

    <ng-container matColumnDef="timeline-header">
      <td colspan="2" mat-cell *matCellDef="let element" class="timeline-header">
        <div class="merged-cells-container">
          <span class="merged-cell-left">{{columnNames.column3title ? columnNames.column3title : 'Timeline'}}</span>
          <span class="merged-cell-right" [style.color]="color">{{element.timeline}}</span>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="timeline">
      <th mat-header-cell *matHeaderCellDef
          class="timeline"> {{columnNames.column3title ? columnNames.column3title : 'Timeline'}} </th>
      <td mat-cell *matCellDef="let element" class="timeline" [style.color]="color"> {{element.timeline}} </td>
    </ng-container>

    <ng-container matColumnDef="status-header">
      <td colspan="2" mat-cell *matCellDef="let element" class="status-header">
        <div class="merged-cells-container">
          <span class="merged-cell-left">{{columnNames.column4title ? columnNames.column4title : 'Status'}}</span>
          <span class="merged-cell-right">
                <span
                  *ngIf="!isActionLayout(element)"
                  class="status-cintainer waves-light" (mouseenter)="applyStyles(element.status.value)"
                  [matTooltipPosition]="toolTipPosition" [matTooltip]="element.status.value">
                  <span class="status" [style.background-color]="
              element.status.value == 'Complete' ? '#35C13B'
              : element.status.value == 'In Progress' ? '#2492D6'
              : '#FFCE00'" [style.width]="
                element.status.value == 'Complete' ? '100%'
                : element.status.value == 'In Progress' ? '70%'
                : '30%'"></span>
                </span>
                <span
                  *ngIf="isActionLayout(element)"
                  class="description simple-text-benefits"
                  [innerHtml]="element.simpleTextStatus"></span>
              </span>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef
          class="status"> {{columnNames.column4title ? columnNames.column4title : 'Status'}} </th>
      <td mat-cell *matCellDef="let element" class="status">
            <span *ngIf="!isActionLayout(element)">
              <span class="status-cintainer waves-light" (mouseenter)="applyStyles(element.status.value)"
                    [matTooltipPosition]="toolTipPosition" [matTooltip]="element.status.value">
              <span class="status" [style.background-color]="
            element.status.value == 'Complete' ? '#35C13B'
            : element.status.value == 'In Progress' ? '#2492D6'
            : '#FFCE00'" [style.width]="
              element.status.value == 'Complete' ? '100%'
              : element.status.value == 'In Progress' ? '70%'
              : '30%'"></span>
            </span>
            </span>

        <span *ngIf="isActionLayout(element)" class="description simple-text-benefits" [innerHtml]="element.simpleTextStatus">

            </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="coBenefits-header">
      <td colspan="2" mat-cell *matCellDef="let element" class="coBenefits-header">
        <div class="merged-cells-container">
              <span
                class="merged-cell-left pr-0">{{columnNames.column5title ? columnNames.column5title : 'Co Benefits'}}</span>
          <span class="merged-cell-right" *ngIf="!isActionLayout(element)">
                <img *ngFor="let coBenefit of element.coBenefits" (mouseenter)="applyStyles(coBenefit.title)"
                     [matTooltipPosition]="toolTipPosition" [matTooltip]="getCoBenefitTitle(coBenefit)"
                     src="{{getCoBenefitIconPath(coBenefit)}}">
              </span>
          <span class="merged-cell-right" *ngIf="isActionLayout(element)">
                <span class="d-flex align-items-center justify-content-center simple-text-benefits description" [innerHtml]="element.simpleTextCoBenefits"></span>
              </span>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="coBenefits">
      <th mat-header-cell *matHeaderCellDef
          class="co-benefits pr-0">{{columnNames.column5title ? columnNames.column5title : 'Co Benefits'}} </th>
      <td mat-cell *matCellDef="let element" class="co-benefits">
            <span *ngIf="!isActionLayout(element)">
              <img *ngFor="let coBenefit of element.coBenefits" (mouseenter)="applyStyles(coBenefit.title)"
                   [matTooltipPosition]="toolTipPosition"
                   [matTooltip]="getCoBenefitTitle(coBenefit)" src="{{getCoBenefitIconPath(coBenefit)}}">
            </span>
        <span class="d-flex align-items-center justify-content-center simple-text-benefits description" *ngIf="isActionLayout(element)" [innerHtml]="element.simpleTextCoBenefits"></span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" tabindex="0" [attr.aria-label]="getRowAriaLabel(row)"></tr>

    <div *ngIf="isMobile()">
      <tr mat-row *matRowDef="let row; columns: ['timeline-header'];"></tr>
      <tr mat-row *matRowDef="let row; columns: ['status-header'];"></tr>
      <tr mat-row *matRowDef="let row; columns: ['coBenefits-header'];"></tr>
    </div>
  </table>
</div>
